import { render, staticRenderFns } from "./LeftWrap4.vue?vue&type=template&id=8d1c37c4&scoped=true"
import script from "./LeftWrap4.vue?vue&type=script&lang=js"
export * from "./LeftWrap4.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap4.vue?vue&type=style&index=0&id=8d1c37c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c37c4",
  null
  
)

export default component.exports